var DK = DK || {};
DK.ProductFamily = {};
DK.ProductFamily.selectSku = function (skuId, position, otherSkuId) {
  const $giftListButton = $('.giftlist-modal-btn');
  const productFamilyId = $('#prd-fam-id-param').val();
  let data = {
    position: position,
    otherSkuId: otherSkuId
  };
  return $.ajax({
    url: `/product/family/${skuId}`,
    cache: true,
    data: data,
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    timeout: 15000
  }).done(function (data) {
    DK.ProductFamily.updateCartInputs(skuId, position);
    DK.ProductFamily.applyJson(data, position);
    DK.ProductFamily.addToCartButtonDisable(data.nlaSelected);
    $('.attr--select').removeClass('is-invalid');
    $('#no-sku-selected.invalid-feedback').hide();
    let $mediaViewer = $('#primary-media-section .pic').mediaViewer();
    $mediaViewer.data('mediaViewer').initImageZoom($('.pic__primary-image').find('img:visible').parent('a'), window);
    $mediaViewer.data('mediaViewer').initSwatches($('.attr__swatch div'));
    if (data.skuStockLevel < 1) {
      DK.product.stockEmail.init();
    }
    if ($('.giftlist-modal-btn').data('login') !== '') {
      $giftListButton.attr('data-bs-target', '#gift-list-modal');
    }
    $giftListButton.removeClass('disabled');
    $('#add-to-cart-form').fadeIn();
    $('#updated-cart').hide().removeClass('d-flex');
    DK.product.skuInfo.updateRecentlyViewedCookie(skuId, productFamilyId);

    //Reinitialize tooltips and popovers
    $('[data-bs-toggle="tooltip"]').tooltip();
    $('[data-bs-toggle="popover"]').popover();
    DK.ProductFamily.updateUrl();

    // Event is caught in Google Tag Manager
    document.dispatchEvent(new Event('tire.changed', {
      bubbles: true
    }));
  });
};
DK.ProductFamily.removeSku = function (position, otherSkuId) {
  let data = {
    position: position,
    otherSkuId: otherSkuId,
    productFamilyId: $('#prd-fam-id-param').val()
  };
  return $.ajax({
    url: '/remove/sku/',
    cache: true,
    data: data,
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    timeout: 15000
  }).done(function (data) {
    DK.ProductFamily.removeCartInputs(position);
    DK.ProductFamily.addToCartButtonDisable(data.selectorContainsNla);
    $(`#${position}-spec .product-tabs-specs__list-group`).replaceWith(data.specificationsHTML);
    $(`.sku-${position} .sku-details`).empty();
    $(`.skuinfo-${position} .sku-details`).empty();
    $(`.${position}-stock-qty`).empty();
    if ($('.sku-details .price[data-lowest-price]').length) {
      let prices = [];
      let totalPrice = 0;
      $('.sku-details .price[data-lowest-price]').each(function () {
        prices.push($(this).data('lowestPrice'));
        totalPrice += parseFloat($(this).data('lowestPrice'));
        $('.affirm-as-low-as').attr('data-amount', totalPrice * 100);
      });
      if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function') {
        affirm.ui.refresh();
      }
    } else {
      let lowestPrice = $('.price--after span').data('min');
      $('.affirm-as-low-as').attr('data-amount', lowestPrice * 100);
      if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function') {
        affirm.ui.refresh();
      }
    }

    // Event is caught in Google Tag Manager
    document.dispatchEvent(new Event('tire.changed', {
      bubbles: true
    }));
  });
};
DK.ProductFamily.applyJson = function (data, position) {
  $(`#${position}-spec .product-tabs-specs__list-group`).replaceWith(data.specificationsHTML);
  $(`#view-addtl-${position}`).show();
  $(`.sku-${position} .sku-details`).html(data.skuInfoHTML).show();
  $(`.skuinfo-${position} .sku-details`).html(data.partInfoHTML).show();
  $(`.${position}-stock-qty`).replaceWith(data.skuInventoryHTML);
  $(`#${position}-spec tbody`).append(data.additionalSpecsHTML);
  $('.select-sku').remove();
  if (data.recommendationsHtml) {
    $('.product-recommendations').html(data.recommendationsHtml);
    DK.Recommendations.initCarousel($('[data-rec-container]'));
  }
  let prices = [];
  let totalPrice = 0;
  $('.sku-details .price[data-lowest-price]').each(function () {
    prices.push($(this).data('lowestPrice'));
    totalPrice += parseFloat($(this).data('lowestPrice'));
    $('.affirm-as-low-as').attr('data-amount', totalPrice * 100);
  });
  if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function') {
    affirm.ui.refresh();
  }

  // Reinitialize the product media viewer
  let $mediaContainer = $('#primary-media-section').find('.pic');
  $mediaContainer.replaceWith(data.productMediaHtml);
  let $mediaViewer = $mediaContainer.mediaViewer();
  $mediaViewer.data('mediaViewer').resetModal();
};
DK.ProductFamily.updateCartInputs = function (skuId, position) {
  let $skuInput = $(`#${position}-skuId`);
  let $qty = $(`.skuinfo-${position}`).find('.qty--select').val();
  if ($skuInput.length > 0) {
    $skuInput.attr('value', skuId).attr('data-gl-sku', skuId);
  } else {
    let $newSkuInput = $('<input/>').attr('id', `${position}-skuId`).attr('class', 'skuIds').attr('hidden', 'hidden').attr('name', `skuId-${position}`).attr('value', skuId).attr('data-gl-sku', skuId).attr('data-gl-position', position);
    $('#add-to-cart-form').prepend($newSkuInput);
  }
};

/*
 * To avoid form-ception with stock qty and cart, had to move the qty out of the
 * cart form. Now it's populating a hidden input in the cart form like the sku
 */
DK.ProductFamily.updateQuantities = function ($qty, $position) {
  let $newQtyInput = $('<input/>').attr('name', `quantity-${$position}`).attr('value', $qty).attr('hidden', 'hidden');
  $('#add-to-cart-form').prepend($newQtyInput);
};
DK.ProductFamily.removeCartInputs = function (position) {
  let $skuInput = $(`#${position}-skuId`);
  if ($skuInput.length > 0) {
    $skuInput.remove();
  }
  $(`.skuinfo-${position}`).find('label').addClass('text-muted');
  $(`.skuinfo-${position}`).find('fieldset').attr('disabled', 'disabled');
};
DK.ProductFamily.updateUrl = function () {
  let tireSkuParams = $('.attr--select').map(function (el) {
    let val = this.options[this.selectedIndex].value;
    if (val && val > 0) {
      // Return a query parameter for the selected tire
      return this.name + '=' + val;
    }

    // No tire selected. The param will be removed from the URL
    return null;
  }).get().join('&');

  // Replace the front and rear tire query parameters with the new ones.
  let currentUrl = document.location.href.replace(/\bskuId=\w+&?/g, '').replace(/\bfs=\w+&?/g, '').replace(/\brs=\w+&?/g, '').replace(/[?#&]+$/g, '');
  let newUrl = currentUrl.indexOf('?') === -1 ? `${currentUrl}?${tireSkuParams}` : `${currentUrl}&${tireSkuParams}`;

  // Update URL without adding anything to the history
  window.history.replaceState('', '', newUrl);
};
$('.qty--select').on('change', function (e) {
  let select = $(e.currentTarget),
    $qty = select.val(),
    $position = select.attr('data-gl-quantity');
  DK.ProductFamily.updateQuantities($qty, $position);
});
$("#add-to-cart-btn-container").on('click', function (e) {
  let selectedSku = $('.attr--select option:enabled[selected]').val();
  if (selectedSku === undefined || selectedSku === '-1') {
    $('.attr--select').each(function (i, e) {
      $(e).addClass('is-invalid');
    });
    $('#no-sku-selected.invalid-feedback').show();
  }
});
DK.ProductFamily.addToCartButtonDisable = function (status) {
  if (status) {
    $('#add-to-cart-button').attr('disabled', 'disabled');
  } else {
    $('#add-to-cart-button').removeAttr('disabled');
  }
};
$(function () {
  let $giftListButton = $('.giftlist-modal-btn');
  //add the different names to the qty select lists
  $('.skuinfo-front .qty--select, .skuinfo-front input').attr('name', 'quantity-front');
  $('.skuinfo-rear .qty--select, .skuinfo-rear input').attr('name', 'quantity-rear');

  // Dropdown toggle
  //Clicked sku Dropdown
  $(document).on('change', '.attr--select', function (e) {
    e.preventDefault();
    let selectOption = $(e.currentTarget).find('option:selected'),
      skuId = selectOption.val(),
      position = selectOption.data('position');
    const otherSkuId = position === 'front' ? $('#rear-sku-selector').find('option:selected').val() : $('#front-sku-selector').find('option:selected').val();
    if (skuId == '-1') {
      DK.ProductFamily.removeSku(position, otherSkuId);
      $(`select.${position}-skus option[selected]`).removeAttr('selected');
      if ($('.attr--select option:enabled[selected]').length === 0) {
        DK.ProductFamily.addToCartButtonDisable(true);
        $giftListButton.addClass('disabled');
      }
      if (otherSkuId === '-1') {
        DK.ProductFamily.addToCartButtonDisable(true);
      }
      DK.ProductFamily.updateUrl();
    } else {
      selectOption.attr('selected', 'selected');
      DK.ProductFamily.selectSku(skuId, position, otherSkuId);
    }
    $(`.skuinfo-${position}`).find('.fee-note-detail').remove();
    $(`.skuinfo-${position}`).find('label').removeClass('text-muted');
    $(`.skuinfo-${position}`).find('fieldset').removeAttr('disabled');
  });

  //Sku selected on page load
  let selectedSku = $('.attr--select option:enabled[selected]');
  $.each(selectedSku, function (index, selectedItem) {
    let selected = $(selectedItem);
    let skuId = selected.val();
    let position = selected.data('position');
    const otherSkuId = position === 'front' ? $('#rear-sku-selector').find('option:selected').val() : $('#front-sku-selector').find('option:selected').val();
    if (skuId != -1) {
      DK.ProductFamily.selectSku(skuId, position, otherSkuId);
      if ($('.giftlist-modal-btn').data('login') !== '') {
        $giftListButton.attr('data-bs-target', '#gift-list-modal');
      }
      $giftListButton.removeClass('disabled');
      $(`.skuinfo-${position}`).find('label').removeClass('text-muted');
      $(`.skuinfo-${position}`).find('fieldset').removeAttr('disabled');
    }
  });
  $(document).on('click', '.giftlist-modal-btn', function (e) {
    let skuIds = $('.skuIds').map(function () {
      return this.value;
    }).get();
    $('.create-new a').each(function (i, e) {
      let href = $(e).attr('href').replace(/skuIds=[\w\d]*/, 'skuIds=' + skuIds.join(','));
      $(e).attr('href', href);
    });
  });
});

//Added popover init because it seems popovers break during ajax requests
$(document).ajaxSuccess(function () {
  $('#primary-media-section .pic').mediaViewer();
});
function affirm() {
  let prices = [];
  let totalPrice = 0;
  $('.sku-details .price[data-lowest-price]').each(function () {
    prices.push($(this).data('lowestPrice'));
    totalPrice += parseFloat($(this).data('lowestPrice'));
    $('.affirm-as-low-as').attr('data-amount', totalPrice * 100);
  });
  if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function') {
    affirm.ui.refresh();
  }
}